import { useMemo, useEffect, createRef, useState } from 'react'
import { IActions } from '../../../interfaces/actions'
import { ICatalogItem } from '../../../interfaces/catalog'

let scrollTimer: NodeJS.Timeout

const useCategoryObserver = (
  catalogue: ICatalogItem[],
  actions: IActions,
  initCategory: string
) => {
  // map all categories ref
  const categoriesRef = useMemo(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const refList: any = {
      all: createRef()
    }
    catalogue?.forEach(({ slug = '' }) => {
      refList[slug] = createRef()
    })
    return refList
  }, [catalogue])

  // observe categories when enters into the viewport and update current category
  const observer = useMemo(() => {
    return new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            clearTimeout(scrollTimer)
            scrollTimer = setTimeout(() => {
              if (actions) {
                const newValue =
                  entry.target.getAttribute('data-category') || 'all'
                const categoryName = entry.target.querySelector<HTMLDivElement>(
                  '[data-category-name]'
                )?.dataset.categoryName
                actions({ newValue, categoryName })
              }
            }, 500)
          }
        })
      },
      {
        rootMargin: `-50% 10px -49% 10px`
      }
    )
  }, [actions])

  // add categories to observer when they are in the DOM
  useEffect(() => {
    Object.keys(categoriesRef).forEach((key) => {
      const target = categoriesRef[key].current

      if (target) {
        observer.observe(target)
      }
    })
    // eslint-disable-next-line
  }, [categoriesRef])

  // scroll to initCategory one time, and only when the DOM is ready
  const [initCategoryScrolled, setInitCategoryScrolled] = useState(false)

  useEffect(() => {
    if (
      !initCategoryScrolled &&
      initCategory &&
      categoriesRef[initCategory]?.current
    ) {
      categoriesRef[initCategory]?.current.scrollIntoView()
      setInitCategoryScrolled(true)
    }
  }, [initCategoryScrolled, initCategory, categoriesRef])

  return categoriesRef
}

export default useCategoryObserver
